export const getExistMap = (id: string) => {
  const url = `/${id}.json?t=${Date.now()}`;
  return fetch(url, { cache: "no-store" }).then((res) => res.text());
};
